import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { useMemo } from 'react';
import { RouterProvider } from 'react-router-dom';
import { NotificationContainer } from 'src/components/NotificationContainer';
import { lightTheme } from 'src/theme';
import { AuthProvider } from './auth/AuthContext';
import { router } from './router';

function App() {
  const theme = useMemo(() => lightTheme, []);

  // useCypressLogger();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <RouterProvider
          router={router}
          future={{
            v7_startTransition: true,
          }}
        />
        <NotificationContainer />
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
